<script context="module" lang="ts">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../../common/config/constants';
  import { getJoodMembershipType } from '../../../../../common/util';

  const userPrimeLevel = getJoodMembershipType();
  const { joodExpiredFlag } = getAppConfig();
  const { BASIC, VIP, SMART, NOPRIME, VIPPRIME, BASICPRIME, SMARTPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import {
    getJoodDayCredits,
    selectCorrectSmartPrice,
    selectCorrectSmartPromoBoolean,
  } from '../../../../../common/joodUtils';
  import GiftCardForm from '../../../../product-details/components/DigitalGiftCardProduct/GiftCardForm.svelte';
  import ProductOccasions from '../../../../product-details/components/DigitalGiftCardProduct/ProductOccasions.svelte';
  import ProductTasheelPrice from '../../../../product-details/components/DigitalGiftCardProduct/ProductTasheelPrice.svelte';
  import JoodDayBannerWallet from '../../../../product-listing-search/components/JoodDayBannerWallet.svelte';
  import JoodDayBannerWalletBenefits from '../../../../product-listing-search/components/JoodDayBannerWalletBenefits.svelte';
  import { ProductTilePriceGroupVariantType } from '../product-tile-main';
  // import ProductSplitPriceCard from './ProductSplitPriceCard.svelte';
  import ProductTilePriceWallet from './ProductTilePriceWallet.svelte';
  import ProductTileWalletBenefits from './productTileWalletBenefits.svelte';

  export let product;
  export let pdpGiftCardPriceData = null;
  export let variant: ProductTilePriceGroupVariantType = 'plp-list';
  export let isMegasaleProduct = [];

  $: visible = getComponentVisibility(product, variant);
  $: isPDPVariantWithGiftCard = variant === 'pdp' && product?.isDigitalGiftCard;
  $: isTacticalBasicPromo = product?.tacticalBasicPromo;
  $: isTacticalVipPromo = product?.tacticalVipPromo;
  $: isTacticalSmartPromo = selectCorrectSmartPromoBoolean(
    product?.tacticalSmartFirstPromo,
    product?.tacticalSmartRepeatingPromo
  );
  $: tacticalBasicPrimePrice = product?.tacticalBasicPrimePrice;
  $: tacticalVipPrimePrice = product?.tacticalVipPrimePrice;
  $: tacticalSmartPrimePrice = selectCorrectSmartPrice(
    product?.tacticalSmartFirstPrimePrice,
    product?.tacticalSmartRepeatingPrimePrice
  );
  $: smartPrimePrice = selectCorrectSmartPrice(product?.smartFirstPrimePrice, product?.smartRepeatingPrimePrice);

  function getComponentVisibility(data, variant) {
    const isPDPVariant = variant === 'pdp';
    if (!isPDPVariant) {
      return !!data;
    }
    return true;
    //return data?.isComingSoon !== true;
  }
</script>

{#if visible}
  <section class="product-tile-price-new-group variant-{variant} c_walletpricegroup">
    {#if isPDPVariantWithGiftCard}
      <ProductTasheelPrice data={pdpGiftCardPriceData} />
      <ProductOccasions data={pdpGiftCardPriceData} />
      <GiftCardForm data={pdpGiftCardPriceData} />
    {:else if userPrimeLevel === BASICPRIME || joodExpiredFlag === BASIC}
      {#if joodExpiredFlag === BASIC || !product?.basicPrimePrice || product?.basicPrimePrice === 0}
        <ProductTilePriceWallet {isMegasaleProduct} {variant} priceType={NOPRIME} algoliaProductHit={product} />
      {/if}
      {#if !isTacticalBasicPromo && product?.basicPrimePrice > 0}
        <ProductTilePriceWallet
          {isMegasaleProduct}
          {variant}
          priceType={BASICPRIME}
          algoliaProductHit={product}
          backgoundOverride={BASICPRIME}
        />
      {:else if tacticalBasicPrimePrice && tacticalBasicPrimePrice > 0}
        <ProductTilePriceWallet
          {isMegasaleProduct}
          {variant}
          priceType={BASICPRIME}
          algoliaProductHit={product}
          backgoundOverride={BASICPRIME}
          showWalletCredits={false}
        />
        <JoodDayBannerWallet {variant} bannerType={BASICPRIME} algoliaProductHit={product} />
      {/if}
    {:else if userPrimeLevel === VIPPRIME || joodExpiredFlag === VIP}
      {#if joodExpiredFlag === VIP || !product?.vipPrimePrice || product?.vipPrimePrice === 0}
        <ProductTilePriceWallet {isMegasaleProduct} {variant} priceType={NOPRIME} algoliaProductHit={product} />
      {/if}
      {#if !isTacticalVipPromo && product?.vipPrimePrice > 0}
        <ProductTilePriceWallet
          {isMegasaleProduct}
          {variant}
          priceType={VIPPRIME}
          algoliaProductHit={product}
          backgoundOverride={VIPPRIME}
        />
      {:else if tacticalVipPrimePrice && tacticalVipPrimePrice > 0}
        <ProductTilePriceWallet
          {isMegasaleProduct}
          {variant}
          priceType={VIPPRIME}
          algoliaProductHit={product}
          backgoundOverride={VIPPRIME}
          showWalletCredits={false}
        />
        <JoodDayBannerWallet {variant} bannerType={VIPPRIME} algoliaProductHit={product} />
      {/if}
    {:else if userPrimeLevel === SMARTPRIME || joodExpiredFlag === SMART}
      {#if joodExpiredFlag === SMART || !smartPrimePrice || smartPrimePrice === 0}
        <ProductTilePriceWallet {isMegasaleProduct} {variant} priceType={NOPRIME} algoliaProductHit={product} />
      {/if}
      {#if !isTacticalSmartPromo && smartPrimePrice > 0}
        <ProductTilePriceWallet
          {isMegasaleProduct}
          {variant}
          priceType={SMARTPRIME}
          algoliaProductHit={product}
          backgoundOverride={SMARTPRIME}
        />
      {:else if tacticalSmartPrimePrice && tacticalSmartPrimePrice > 0}
        <ProductTilePriceWallet
          {isMegasaleProduct}
          {variant}
          priceType={SMARTPRIME}
          algoliaProductHit={product}
          backgoundOverride={SMARTPRIME}
          showWalletCredits={false}
        />
        <JoodDayBannerWallet {variant} bannerType={SMARTPRIME} algoliaProductHit={product} />
      {/if}
    {:else}
      <ProductTilePriceWallet {isMegasaleProduct} {variant} priceType={NOPRIME} algoliaProductHit={product} />

      {#if !isTacticalVipPromo && product?.vipPrimePrice > 0 && variant === 'pdp'}
        <ProductTileWalletBenefits
          isTacticalFlag={false}
          creditPoints={getJoodDayCredits(VIPPRIME, product)}
          {variant}
        />
      {:else if isTacticalVipPromo && product?.vipPrimePrice > 0 && variant === 'pdp'}
        <JoodDayBannerWalletBenefits
          algoliaProductHit={product}
          creditPoints={getJoodDayCredits(VIPPRIME, product)}
          {variant}
        />
      {/if}
    {/if}

    <!-- {#if variant !== 'pdp'}
      <ProductSplitPriceCard {variant} algoliaProductHit={product} />
    {/if} -->
    <!-- cashback section commented for MAVD-12152    -->
    <!-- {#if variant === "product-tile" && cashback > 0}
        <section class="cashback">
            <Tag label="{!isRTL ? currency:""} {formatNumber(cashback)} {isRTL ? currency:""} {$_('rrBlock.cashback')}" fontSize={11} theme="orange" />
        </section>
    {/if} -->
  </section>
{/if}

<style lang="scss">
  @import '../../../../common/styles/colors.new.scss';

  .product-tile-price-new-group {
    &.variant- {
      &product-tile {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      &plp-list,
      &pdp {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
      &.plp-list {
        @include responsive {
          gap: 4px;
        }
      }
    }
  }
</style>
